var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveroo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 937.4 964.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #35b8b2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m582.3,0h0l-29.6,317.8-50.5-267.9-158.5,38,50.5,267.9-228.5,54.7,40.4,214,401.7,96.2,91.9-232.5,43.7-469L582.3,0Zm-126.9,461h0c-8.3,8.6-19.3,7.8-30.9,3.4-11.6-4.3-16.8-20.2-12.4-39.3,3.3-14.2,18.7-16.3,26.4-16.5,2.9-.1,5.8.6,8.5,2,5.5,2.8,14.7,8.7,16.6,17.8,2.7,13,.1,24-8.2,32.6Zm116.3,14.7h0c-6.1,11.8-21.9,13.3-37.4,4.8-10.5-5.8-10.4-20.5-9.2-29.5.6-4.9,2.4-9.5,5.1-13.4,3.7-5.3,10-12.3,17.2-12.5,11.7-.4,21.8,5.6,27.5,16.3,5.7,10.7,2.9,22.5-3.2,34.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m672.3,834.9c-14.3,0-26.3,6.5-33.9,18.5l-3.4-15.7h-32.7l5.3,24.3v100h31.8v-79.2c4.3-8.2,12.4-13.2,22.9-13.2h0c6.5,0,12.4,1.7,17.9,5.5l15.1-34c-7-4.3-15.1-6.2-23-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m744.6,835.1c-36.1,0-62.9,26.3-62.9,64.8s26.8,64.8,62.8,64.8h0c36.1,0,62.8-26.2,62.8-64.8.2-38.5-26.6-64.8-62.7-64.8Zm0,96.1h0c-18.4,0-32-12.3-32-31.3s13.6-31.3,32-31.3,32,12,32,31.3c.1,19.1-13.3,31.3-32,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m874.6,835.1c-36.1,0-62.9,26.3-62.9,64.8s26.8,64.8,62.8,64.8,62.9-26.2,62.9-64.8h0c.1-38.5-26.7-64.8-62.8-64.8Zm0,96.1c-18.4,0-32-12.3-32-31.3s13.6-31.3,32-31.3,32,12,32,31.3-13.3,31.3-32,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.4,782.6h-31.8v70.1c-9.6-11.1-22.7-17.6-38.2-17.6-31.8,0-56.4,26.2-56.4,64.8s24.6,64.8,56.4,64.8c15.8,0,29.4-6.7,39-18.3l3.3,15.7h33.2l-5.5-25.8v-153.7Zm-63.6,148.6c-18.4,0-32-12.3-32-31.3s13.6-31.3,32-31.3,32,12,32,31.3c.1,19.1-13.3,31.3-32,31.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "416.4 938.5 392 837.8 357.9 837.8 391.1 962.1 391.1 962.1 391.1 962.1 442.2 962.1 475.4 837.8 440.8 837.8 416.4 938.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m535.4,835.1c-35.8,0-62.1,26-62.1,64.8s26.1,64.8,66.4,64.8h0c17.7,0,35.1-4.8,49.7-14.2l-12.2-27.5c-11.5,6-24.1,9.6-37,9.6-16.7,0-28.4-6.5-33.5-18.5h89.4c1-4.6,1.4-9.1,1.4-14.7,0-38.5-26.5-64.3-62.1-64.3Zm-30.6,53.5c3.6-14.2,14.3-21.9,30.6-21.9s27.3,7.7,30.6,21.9h-61.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.9,834.8c-35.8,0-62.1,26-62.1,64.8s26,64.8,66.4,64.8c17.7,0,35.1-4.8,49.7-14.2l-12.2-27.5c-11.5,6-24.1,9.6-37,9.6-16.7,0-28.4-6.5-33.5-18.5h89.4c1-4.6,1.4-9.1,1.4-14.7,0-38.5-26.5-64.3-62.1-64.3Zm-31.2,53.8c3.6-14.2,14.3-21.9,30.6-21.9h0c16.5,0,27.2,7.7,30.6,21.9h-61.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m335.9,780.2c-11.5,0-20.1,8.7-20.1,20.2s8.6,20.2,20.1,20.2h0c11.2,0,19.8-8.7,19.8-20.2s-8.6-20.2-19.8-20.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 319.9,
    y: 837.8,
    width: 31.8,
    height: 124.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "270.4 962.1 270.5 962.1 302.2 962.1 302.2 782.6 270.4 782.6 270.4 962.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveroo);
export default __webpack_public_path__ + "static/media/Deliveroo.043d1b025a0109cb5a4b367e2cd75530.svg";
export { ForwardRef as ReactComponent };